import { isValidEan } from '@makila/pos-core';

/**
 * Código de barras EAN-13 / EAN-8 em SVG, para as etiquetas de preço
 * (GS1: conjuntos L, G e R; o primeiro dígito do EAN-13 escolhe a paridade).
 */
const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const G = ['0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'];
const R = ['1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'];
const PARITY = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/** Módulos (1 = barra) do código; null se não for EAN válido. */
export function eanModules(code: string): string | null {
  if (!isValidEan(code)) return null;
  const d = [...code].map(Number);
  if (code.length === 8) return `101${d.slice(0, 4).map((x) => L[x]).join('')}01010${d.slice(4).map((x) => R[x]).join('')}101`;
  const par = PARITY[d[0]!]!;
  return `101${d.slice(1, 7).map((x, i) => (par[i] === 'L' ? L : G)[x]).join('')}01010${d.slice(7).map((x) => R[x]).join('')}101`;
}

/** SVG do código (largura em módulos + margens), com os dígitos por baixo. */
export function eanSvg(code: string, heightMm = 12): string | null {
  const m = eanModules(code);
  if (!m) return null;
  const quiet = 7;
  const w = m.length + quiet * 2;
  let bars = '';
  for (let i = 0; i < m.length; i++) if (m[i] === '1') bars += `<rect x="${i + quiet}" y="0" width="1" height="50"/>`;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} 60" style="height:${heightMm}mm;width:auto" role="img" aria-label="${code}"><g fill="#000">${bars}</g><text x="${w / 2}" y="59" font-family="monospace" font-size="9" text-anchor="middle">${code}</text></svg>`;
}
